import { Component, DestroyRef, Inject, ViewChild, inject, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface myStallData {
  so_id: string;
  stall_num: string;
  company_name: string;
  website: string;
  youtube: string;
  facebook: string;
  instagram: string;
}

@Component({
  selector: 'app-stall-scan',
  templateUrl: './stall-scan.component.html',
  styleUrls: ['./stall-scan.component.scss']
})
export class StallScanComponent {
  displayedColumns: string[] = [
    'so_id',
    'mem_id',
    'name',
    'mobile',
    'date',
    'time'
  ];

  ELEMENT_DATA: myStallData[] = [];
  stall_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<myStallData>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  so_id: any;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    console.log(this.route);

    this.route.params.subscribe(params => {
      console.log(params);
      this.so_id = params['so_id'];
      this.GetStallOwner(this.so_id);
    });
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  export() {
    this.service.export_stall_scan(this.so_id).subscribe(
      (response: any) => {
        this.downloadFile(response, 'registration' + '.csv', 'text/csv');
      },
      (error) => {
        console.error('Error exporting main member table:', error);
      }
    );
  }

  downloadFile(data: any, filename: string, contentType: string) {
    const blob = new Blob([data], { type: contentType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  GetStallOwner(so_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    console.log(so_id);

    this.service.get_stall_scan(so_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.stall_result = data.data
        for (const item of this.stall_result) {
          this.ELEMENT_DATA = this.stall_result.map((item: { mem_id: any; mobile: any; name: any; date: any, time: any; }, index: number) => ({
            srNo: index + 1,
            mem_id: item.mem_id,
            name: item.name,
            mobile: item.mobile,
            date: item.date,
            time: item.time
          })
          );
        }
        this.dataSource = new MatTableDataSource<myStallData>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      }
    );
  }
}
